function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.416 5.95l7.917-4.572L16.25 5.95",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.334 10.417v9.167L.417 15.027V5.833",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 9.583V5.95l-7.917 4.57v9.065l2.694-1.551M13.268 4.217L5.416 8.75v4.287L4.378 11.64l-1.045.197V7.5l7.915-4.57M5.6 8.94l2.734 1.58M.417 5.95l2.958 1.706",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.52 12.898L15.417 15l-2 2M13.418 12.898L15.52 15l2 2",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.417 19.167a4.167 4.167 0 110-8.334 4.167 4.167 0 010 8.334z",
  stroke: "currentColor",
  strokeWidth: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgWiderrufen = function SvgWiderrufen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNDE2NDY3IDUuOTQ5Mkw4LjMzMzIzIDEuMzc4M0wxNi4yNSA1Ljk0OTIiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMzMzOTggMTAuNDE2N1YxOS41ODM1TDAuNDE3MjE3IDE1LjAyNzZWNS44MzMzNyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIwLjYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjI1IDkuNTgzMjhWNS45NDkyMkw4LjMzMzIzIDEwLjUxOVYxOS41ODM1TDExLjAyNzUgMTguMDMyOCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIwLjYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjI2NzYgNC4yMTcwNkw1LjQxNjA4IDguNzUwMlYxMy4wMzczTDQuMzc3NjcgMTEuNjM5MkwzLjMzMjY2IDExLjgzNjFWNy40OTk4NkwxMS4yNDc2IDIuOTMwNDIiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC42IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjU5OTM2IDguOTQwNTVMOC4zMzM5OCAxMC41MTkxIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjAuNiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMC40MTc0NDEgNS45NDkyMkwzLjM3NSA3LjY1NjQzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjAuNiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuNTE5NSAxMi44OTc5TDE1LjQxNzQgMTUuMDAwMUwxMy40MTc1IDE3IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjAuNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxwYXRoIGQ9Ik0xMy40MTggMTIuODk3OUwxNS41MjAxIDE1LjAwMDFMMTcuNTIgMTciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC42IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTE1LjQxNzIgMTkuMTY2OUMxMy4xMTU5IDE5LjE2NjkgMTEuMjUwMyAxNy4zMDE0IDExLjI1MDMgMTUuMDAwMUMxMS4yNTAzIDEyLjY5ODggMTMuMTE1OSAxMC44MzMzIDE1LjQxNzIgMTAuODMzM0MxNy43MTg0IDEwLjgzMzMgMTkuNTg0IDEyLjY5ODggMTkuNTg0IDE1LjAwMDFDMTkuNTg0IDE3LjMwMTQgMTcuNzE4NCAxOS4xNjY5IDE1LjQxNzIgMTkuMTY2OVoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgWiderrufen as ReactComponent };